module.exports = __webpack_public_path__ + "static/media/quote-angelou-feel.243a2b1f.png";